/**
 * 环境配置
 *
 * - VITE_API_BASE 优先（生产 / staging 用 .env.production / .env.staging 注入）
 * - dev 时缺省回退 http://localhost:3001
 */

const env = import.meta.env as Record<string, string | undefined>
const apiBase =
  env.VITE_API_BASE ?? (env.DEV ? 'http://localhost:3001' : 'https://api.socialslots.ai')
const wsBase = apiBase.replace(/^http/, 'ws')

export const ApiConfig = {
  apiBase,
  wsBase,

  // 设计分辨率(竖屏 9:16)
  designWidth: 1080,
  designHeight: 1920,
} as const
